import { Button } from "blocks/components";
import { DisembodiedHeader } from "blocks/components/DisembodiedHeader";
import { strings } from "../../strings";

export function KanbanHeader({
  title,
  newCardButtonCopy,
  onClickCreate,
}: {
  title: string | undefined;
  newCardButtonCopy?: string;
  onClickCreate?: () => void;
}) {
  if (!title && !onClickCreate) return null;

  return (
    <DisembodiedHeader
      renderRight={() => {
        if (onClickCreate)
          return (
            <Button onClick={() => onClickCreate()} size="small">
              {newCardButtonCopy || strings.NEW_CARD_BUTTON_DEFAULT_COPY}
            </Button>
          );
      }}
    >
      {title}
    </DisembodiedHeader>
  );
}
